import React, { useEffect, useState } from "react";
import { AccountCircle as IconUser } from "@mui/icons-material";
import { withSnackbar } from "notistack";

import TxtRow from "components/Custom/TxtRow";
import Skeleton from "components/Custom/SkeletonBox";
import Btn from "components/Custom/Btn";
import { LABELS, SUCCESS } from "common/lables";
import { COLORS } from "common/colors";
import { DateFunctions } from "common/datefunctions";
import { DEFAULTS, FORMATS, NOTIFY } from "common/config";
import { COMMON_JS } from "common/scripts";

import { CRM_APIs } from "apihandlers/crm";

interface defaultProps {}

const Comments = (props: any) => {
  const {
    selectedRow,
    isButtonDisabled,
    remarksList,
    getCrmRemarks,
    remarksLoading,
    setRemarksLoading,
  } = props;
  const [inputValue, setInputValue] = useState("");
  const saveRecord = async () => {
    const followupDate = (
      document.getElementById("followupDate") as HTMLInputElement
    ).value.trim();
    const remarks = (
      document.getElementById("remarks") as HTMLInputElement
    ).value.trim();

    let argsRemarks = [];
    if (remarks) {
      argsRemarks = remarksList
        ? [...remarksList, { followupDate: followupDate, remarks: remarks }]
        : [{ followupDate: followupDate, remarks: remarks }];
    }

    const args = {
      crmLeadId: selectedRow.id,
      remarks: argsRemarks,
    };
    console.log("args", args);
    const res = await CRM_APIs.manageCrmRemarks(args);
    try {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);

        setRemarksLoading(true);
        getCrmRemarks();
      }
    } catch (error) {
      console.error("manageCrmLeadProfile: error:", error);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;

    const regex = /^[a-zA-Z0-9 ]*$/;

    if (value.match(regex)) {
      setInputValue(value);
    }
  };

  return (
    <React.Fragment>
      <div className="flexRowJustify" style={{ paddingTop: "1rem" }}>
        <div className="width50">
          <div className="formGroup width45 ">
            <TxtRow
              id={"followupDate"}
              type={"datetime-local"}
              label={LABELS.FOLLOWUP_DATE}
              defaultValue={DateFunctions.getDate(
                "now",
                "from",
                FORMATS.SQL_DATE
              )}
              //disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"remarks"}
              type={"text"}
              label={LABELS.REMARKS}
              //   defaultValue={selectedRemarks.newLead || " "}
              //disabled={isSubmit}
              rows={4}
              onChange={handleChange}
              value={inputValue}
            />
          </div>
          {isButtonDisabled && (
            <div className="formGroup submitBtnWrapper">
              <div className=" flexRowAround">
                <Btn
                  text={LABELS.SAVE}
                  onClick={saveRecord}
                  bgColor={COLORS.SAVE_GREEN}
                  getCrmRemarks={getCrmRemarks}
                  // disabled={isButtonDisabled}
                />
              </div>
            </div>
          )}
        </div>
        {remarksList &&
          (!remarksLoading ? (
            <div className="width45">
              <div>
                <p style={{ fontWeight: "bold", paddingLeft: "1rem" }}>
                  {" Remarks"}
                </p>
              </div>
              <div
                style={{
                  height: "30rem",
                  overflowY: "scroll",
                  padding: "0.1rem 1rem 1rem 1rem",
                }}
              >
                {remarksList &&
                  remarksList.map((items, index) => {
                    return (
                      <div id="responseList" key={index}>
                        <div>
                          <div>
                            <div className="responseHeader">
                              <div className="userBox">
                                <div>
                                  <IconUser />
                                </div>
                                <p
                                  style={{ padding: "0rem 0rem 0.5rem 0.5rem" }}
                                >
                                  {items.userName}
                                </p>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <p
                                  style={{
                                    marginRight: 10,
                                  }}
                                >
                                  <b>{"Date :"}</b>
                                  {items.followupDate.substr(0, 10)}
                                  <b>{" Time :"} </b>
                                  {items.followupDate.substr(11)}
                                </p>
                              </div>
                            </div>
                            <div className="responseText">{items.remarks}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          ) : (
            <div className="width45">
              <Skeleton
                width={"99%"}
                height={150}
                style={{ marginBottom: "1rem", borderRadius: "0.5rem" }}
              />
              <Skeleton
                width={"99%"}
                height={150}
                style={{ marginBottom: "1rem", borderRadius: "0.5rem" }}
              />
              <Skeleton
                width={"99%"}
                height={150}
                style={{ marginBottom: "1rem", borderRadius: "0.5rem" }}
              />
            </div>
          ))}
      </div>
    </React.Fragment>
  );
};
export default withSnackbar(Comments);
